// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zs8QT","left":"styles_left__3odkt","right":"styles_right__2J45U","alert":"styles_alert__2UCAt"};